import * as React from "react";
import { IAdmin, IChangePassword, IDataCenter } from "../../vm";
import {
  deleteDataCenterManager,
  getAllAdmins,
  getUsersExcel,
  updateDataCenterManagerPassword,
} from "../../services/datacenter/DataCenterManagerService";
import {
  IColumn,
  Stack,
  TooltipHost,
  IStackTokens,
  Text,
  PrimaryButton,
  DetailsListLayoutMode,
  SelectionMode,
  Fabric,
  DetailsList,
  Callout,
  DefaultButton,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  DirectionalHint,
  ITag,
} from "office-ui-fabric-react";
import Icon from "@mdi/react";
import {
  mdiPencilOutline,
  mdiTrashCanOutline,
  mdiAccountMultipleOutline,
  mdiFormTextboxPassword,
  mdiDotsVertical,
} from "@mdi/js";
import { THEME } from "../../utils/Styles";
import { Loading } from "../../services/Loading";
import NoDataTile from "../common/NoDataTile";
import ManageAdminDialog from "./ManageAdminDialog";
import {
  ADMIN_ROLES_DIC,
  ADMIN_ROLES,
  childrenGap8,
  childrenGap,
} from "../common/Constants";
import PageTitle from "../common/PageTitle";
import { ToastContext } from "../common/ToastProvider";
import { CustomTextField } from "../common/Library";
import { Formik, FormikErrors } from "formik";
import { ADMIN_USER_ROLES, isValidPassword, parseJwt } from "../../services/UtilService";
import PasswordPolicy from "../common/PasswordPolicy";
import AdminsIcon from "../../images/admins.svg";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";
import ManageAccDialog from "./ManageAccDialog";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";
import CustomPagination from "../common/CustomPagination";

const wrapStackTokens: IStackTokens = { childrenGap: 16 };

export interface AdminMainProps { }

const AdminMain: React.FC<AdminMainProps> = () => {
  const [state, setState] = React.useState({
    admins: [],
    totalCount: 0,
    datacenters: [],
    manageAdminDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    searchObj: {
      offset: 0,
      limit: 10,
      roles: [0, 2, 3, 4, 5],
      showPagination: true,
    },
    isLoading: false,
    isDataLoaded: false,
    changePassword: {
      newPassword: undefined,
      userId: undefined,
    },
    updatePassword: {
      isOpen: false,
      element: undefined,
      userId: undefined,
      role: -1,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    manageAssignCemCustomerDialog: {
      isOpen: false,
      cemId: undefined,
    },
  } as {
    admins: IAdmin[];
    totalCount: number;
    datacenters: ITag[];
    searchObj: {
      offset: number;
      limit: number;
      roles: number[];
      showPagination: boolean;
    };
    isDataLoaded: boolean;
    manageAdminDialog: {
      isOpen: boolean;
      index?: number;
      data?: IAdmin;
    };
    changePassword: IChangePassword;
    updatePassword: {
      isOpen: boolean;
      element: any;
      userId?: string;
      role?: number;
    };
    isLoading: boolean;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IAdmin;
    };
    manageAssignCemCustomerDialog: {
      isOpen: boolean;
      cemId?: string;
    };
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt();

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllDataCenter();
    };
    asyncFunc();
  }, []);

  const getAllDataCenter = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCenters();
    if (result?.success) {
      let datacenters: ITag[] = [];
      result.data.forEach((d) => {
        datacenters.push({
          key: d._id as string,
          name: d.name,
        });
      });
      let obj = {
        ...state,
        datacenters,
        isLoading: false,
      };
      setState(obj);
      getAdmins(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while getting datacenters", "error");
    }
  };

  const getAdmins = async (paramState: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...localState, ...paramState };
    }
    setState({
      ...localState,
      isLoading: true,
    });

    if (tokenData.role === 4) {
      localState.searchObj.roles = [2, 5];
      // localState.searchObj.roles = [2];
    }
    let result = await getAllAdmins(localState.searchObj);

    if (result && result.success) {
      setState({
        ...localState,
        admins: result.data?.admins || [],
        totalCount: result.data?.count || 0,
        isDataLoaded: true,
        isLoading: false,
      });
    } else {
      showToast(result.message || "Error while getting Admins", "error");
      setState({
        ...state,
        isLoading: false,
      });
    }
  };

  const handleManageDialogOpen = (isOpen: boolean, index?: number) => {
    let admins = undefined;
    if (index !== undefined) {
      admins = {
        ...state.admins[index],
      };
    }
    setState({
      ...state,
      manageAdminDialog: {
        isOpen: isOpen,
        index: index,
        data: admins,
      },
    });
  };

  const handleCloseManageDialog = (data: IAdmin) => {
    let admins = [...state.admins];
    if (data) {
      if (state.manageAdminDialog.index !== undefined) {
        admins[state.manageAdminDialog.index] = data;
      } else {
        admins.unshift(data);
      }
    }
    setState({
      ...state,
      manageAdminDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      admins,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deleteAAdmin = (admins: IAdmin, customerIndex: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete admin",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteDataCenterManager(admins);
        if (result.success) {
          showToast("Admin deleted successfully", "success");
          let admins = [...state.admins];
          admins.splice(customerIndex, 1);
          setState({
            ...state,
            admins,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(result.message || "Error while deleting admin", "error");
        }
      }
    );
  };

  const updatePassword = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    userId?: string,
    role?: number
  ) => {
    setState({
      ...state,
      updatePassword: {
        isOpen,
        userId,
        role,
        element: isOpen ? ele?.currentTarget : undefined,
      },
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color="#135c8a"
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={"Edit Admin"}
          //     id={`editAdmin`}
          //     calloutProps={{
          //       gapSpace: 0,
          //     }}
          //     styles={{
          //       root: {
          //         display: "inline-block",
          //       },
          //     }}
          //   >
          //     <span onClick={() => handleManageDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={"Change Password"}
          //     id={`cPDm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={(ele) => updatePassword(true, ele, item._id)}>
          //       <Icon
          //         path={mdiFormTextboxPassword}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   {/* &nbsp;&nbsp;
          //   <TooltipHost content={"Delete Admin"} id={`deleteAdmin`} calloutProps={{ gapSpace: 0 }} styles={{ root: { display: "inline-block" } }}>
          //     <span onClick={() => deleteAAdmin(item, index)}>
          //       <Icon path={mdiTrashCanOutline} size={0.8} className="pointer" color={THEME.palette.themePrimary} />
          //     </span>
          //   </TooltipHost> */}
          // </Stack>
        );
      case "role":
        return <span>{ADMIN_ROLES_DIC[item.role]}</span>;
      case "isEnabled":
        return <span>{item.isEnabled ? "Yes" : "No"}</span>;
      case "name":
        return (
          <Text styles={{ root: { fontWeight: 600 } }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const childrenGap24: IStackTokens = {
    childrenGap: 24,
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IAdmin
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
      updatePassword: {
        ...state.updatePassword,
        isOpen: false,
      },
    });
  };

  const handleAccDialogOpenClose = (isOpen: boolean, cemId?: string) => {
    setState({
      ...state,
      manageAssignCemCustomerDialog: {
        isOpen,
        cemId: cemId ? cemId : undefined,
      },
    });
  };

  const getAdminsFrom = async (from: number) => {
    let localState = { ...state };
    localState.searchObj.offset = from;

    await getAdmins(localState);
  };

  const downloadReport = async () => {
    const result = await getUsersExcel();
    let xlsx = await result.blob();
    const xlFile = await new Blob([xlsx], {
      type: "application/vnd.openxmlformats",
    });
    const xlFileURL = await URL.createObjectURL(xlFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = xlFileURL;
    a.download = `MOR Users Details.xlsx`;
    a.click();
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap24}>
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between">
            <Stack.Item>
              {/* <Text variant="xLarge">Admins</Text> */}
              <PageTitle
                icon={AdminsIcon}
                title="Admins"
                description="List of all admins"
              />
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton text="Export Users" onClick={downloadReport} />
            </Stack.Item> */}
            {/* <Stack.Item>
              <PrimaryButton
                text="Add Admin"
                onClick={() => handleManageDialogOpen(true)}
                className="borderless-btn bg-white"
              />
            </Stack.Item> */}
          </Stack>
        </Stack.Item>
        {/* newly added */}
        <Stack.Item>
          <Stack horizontal horizontalAlign="end" tokens={childrenGap} wrap>
            {[0].includes(tokenData.role) && (
              <Stack.Item>
                <PrimaryButton text="Export Users" onClick={downloadReport} />
              </Stack.Item>
            )}
            {![4].includes(tokenData.role) && (
              <Stack.Item align="end">
                <PrimaryButton
                  text="Add Admin"
                  onClick={() => handleManageDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
                {/* <PrimaryButton text="Add Customer Rack" onClick={() => this.handleAddDialogCustomerRackOpen(true)} /> */}
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>

        {/* <Stack.Item>
          <DefaultButton text="Export Users" onClick={downloadReport} />
        </Stack.Item> */}
        {/* {![4].includes(tokenData.role) && (
          <Stack.Item align="end">
            <PrimaryButton
              text="Add Admin"
              onClick={() => handleManageDialogOpen(true)}
              className="borderless-btn bg-white"
            /> */}
        {/* <PrimaryButton text="Add Customer Rack" onClick={() => this.handleAddDialogCustomerRackOpen(true)} /> */}
        {/* </Stack.Item>
        )} */}
        <Stack.Item>
          <div>
            {state.admins && state.admins.length > 0 ? (
              <Fabric>
                <DetailsList
                  items={state.admins}
                  columns={
                    // ![4].includes(tokenData.role) ?
                    [
                      {
                        key: "name",
                        name: "Name",
                        fieldName: "name",
                        minWidth: 200,
                        maxWidth: 400,
                        isResizable: true,
                      },
                      {
                        key: "email",
                        name: "Email",
                        fieldName: "email",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "role",
                        name: "Role",
                        fieldName: "role",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "isEnabled",
                        name: "Is Enabled",
                        fieldName: "email",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 200,
                        maxWidth: 200,
                        isResizable: true,
                      },
                    ]
                    // : [
                    //   {
                    //     key: 'name',
                    //     name: 'Name',
                    //     fieldName: 'name',
                    //     minWidth: 200,
                    //     maxWidth: 400,
                    //     isResizable: true,
                    //   },
                    //   {
                    //     key: 'email',
                    //     name: 'Email',
                    //     fieldName: 'email',
                    //     minWidth: 250,
                    //     maxWidth: 350,
                    //     isResizable: true,
                    //   },
                    //   {
                    //     key: 'role',
                    //     name: 'Role',
                    //     fieldName: 'role',
                    //     minWidth: 200,
                    //     maxWidth: 300,
                    //     isResizable: true,
                    //   },
                    //   {
                    //     key: 'isEnabled',
                    //     name: 'Is Enabled',
                    //     fieldName: 'email',
                    //     minWidth: 200,
                    //     maxWidth: 300,
                    //     isResizable: true,
                    //   },
                    // ]
                  }
                  compact={true}
                  setKey="set"
                  onRenderItemColumn={_renderItemColumn as any}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                />
              </Fabric>
            ) : (
              <NoDataTile title="No Admin Found"></NoDataTile>
            )}
          </div>
        </Stack.Item>
        {state.isDataLoaded && (
          <Stack.Item>
            <CustomPagination
              name="Admins"
              search={state.searchObj}
              totalCount={state.totalCount}
              getFrom={getAdminsFrom}
            />
          </Stack.Item>
        )}
      </Stack>
      {state.manageAdminDialog.isOpen && (
        <ManageAdminDialog
          closeManageDialog={(data: IAdmin) => handleCloseManageDialog(data)}
          data={state.manageAdminDialog.data}
          handleLoading={handleLoading}
          datacenters={state.datacenters}
        />
      )}
      {state.manageAssignCemCustomerDialog.isOpen && (
        <ManageAccDialog
          cemId={state.manageAssignCemCustomerDialog.cemId as string}
          handleDialogClose={(isOpen: boolean) =>
            handleAccDialogOpenClose(isOpen)
          }
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{
            root: {
              width: state.updatePassword.isOpen ? 300 : 200,
              padding: state.updatePassword.isOpen ? 5 : 20,
            },
          }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          {state.updatePassword.isOpen ? (
            <Formik
              initialValues={state.changePassword}
              // validationSchema={changePasswordSchema}
              validate={(values: any) => {
                let errors: FormikErrors<{ newPassword?: string }> = {};

                if (
                  values.newPassword &&
                  !isValidPassword(values.newPassword, ADMIN_USER_ROLES.includes(state.updatePassword.role as number))
                ) {
                  errors.newPassword = "Please enter valid password.";
                }

                return errors;
              }}
              onSubmit={async (values: IChangePassword, { setSubmitting }) => {
                let obj = { ...values };
                obj.userId = state.updatePassword.userId;
                let result;
                handleLoading();
                result = await updateDataCenterManagerPassword(
                  obj.userId as string,
                  obj.newPassword as string
                );
                handleLoading();
                updatePassword(false);
                handleCallOutOpenClose(false);
                if (result.success) {
                  showToast("Password updated successfully", "success");
                } else {
                  showToast(
                    result.message || "Error while updating password",
                    "error"
                  );
                }
                setSubmitting(false);
              }}
            >
              {({ handleSubmit, errors, touched, values }) => (
                <form onSubmit={handleSubmit}>
                  <Stack
                    wrap
                    tokens={wrapStackTokens}
                    styles={{ root: { padding: "10px" } }}
                  >
                    <Stack.Item>
                      <CustomTextField
                        name={"newPassword"}
                        type="password"
                        label={"Update Password"}
                        placeholder="Enter new password"
                      />
                    </Stack.Item>
                    {errors.newPassword &&
                      touched.newPassword &&
                      values.newPassword && (
                        <Stack.Item>
                          <PasswordPolicy password={values.newPassword} isAdmin={ADMIN_USER_ROLES.includes(state.updatePassword.role as number)} />
                        </Stack.Item>
                      )}
                    <Stack.Item align="end">
                      <DefaultButton
                        text="Cancel"
                        onClick={() => {
                          handleCallOutOpenClose(false);
                        }}
                        className="borderless-btn"
                      />
                      &nbsp;&nbsp;
                      <PrimaryButton text="Update" type="submit" />
                    </Stack.Item>
                  </Stack>
                </form>
              )}
            </Formik>
          ) : (
            <Stack tokens={childrenGap8}>
              {tokenData.role !== 4 && (
                <Stack.Item className="pointer">
                  <span
                    onClick={() => {
                      handleManageDialogOpen(
                        true,
                        state.manageActionsCallout.index
                      );
                    }}
                    className="callout-options"
                  >
                    Edit
                  </span>
                </Stack.Item>
              )}
              {state.manageActionsCallout.data?.role === 2 && (
                <Stack.Item className="pointer">
                  <span
                    onClick={() =>
                      handleAccDialogOpenClose(
                        true,
                        state.manageActionsCallout.data?._id
                      )
                    }
                    className="callout-options"
                  >
                    View Assign Customer
                  </span>
                </Stack.Item>
              )}
              {tokenData.role !== 4 && (
                <Stack.Item className="pointer">
                  <span
                    onClick={
                      () =>
                        setState({
                          ...state,
                          updatePassword: {
                            ...state.updatePassword,
                            isOpen: true,
                            userId: state.manageActionsCallout.data
                              ?._id as string,
                              role: state.manageActionsCallout.data?.role
                          },
                        })
                      // updatePassword(
                      //   true,
                      //   state.manageActionsCallout.element,
                      //   state.manageActionsCallout.data?._id as string,
                      //   state.manageActionsCallout.data?.role
                      // )
                    }
                    className="callout-options"
                  >
                    Update Password
                  </span>
                </Stack.Item>
              )}
              {tokenData.role === 0 && (
                <Stack.Item className="pointer">
                  <span
                    onClick={() =>
                      deleteAAdmin(
                        state.manageActionsCallout.data as IAdmin,
                        state.manageActionsCallout.index as number
                      )
                    }
                    className="callout-options"
                  >
                    Delete
                  </span>
                </Stack.Item>
              )}
            </Stack>
          )}
        </Callout>
      )}
      {/* {state.updatePassword.isOpen && (
        <Callout
          styles={{ root: { width: 300 } }}
          role="alert-dialog"
          ariaLabelledBy={state.updatePassword && state.updatePassword.userId}
          target={state.updatePassword.element}
          className="ms-CalloutExample-callout"
          gapSpace={0}
          onDismiss={() => updatePassword(false)}
          // setInitialFocus={true}
        >
          <Formik
            initialValues={state.changePassword}
            // validationSchema={changePasswordSchema}
            validate={(values: any) => {
              let errors: FormikErrors<{ newPassword?: string }> = {};

              if (values.newPassword && !isValidPassword(values.newPassword)) {
                errors.newPassword = "Please enter valid password.";
              }

              return errors;
            }}
            onSubmit={async (values: IChangePassword, { setSubmitting }) => {
              let obj = { ...values };
              obj.userId = state.updatePassword.userId;
              let result;
              handleLoading();
              result = await updateDataCenterManagerPassword(
                obj.userId as string,
                obj.newPassword as string
              );
              handleLoading();
              updatePassword(false);
              if (result.success) {
                showToast("Password updated successfully", "success");
              } else {
                showToast(
                  result.message || "Error while updating password",
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, errors, touched, values }) => (
              <form onSubmit={handleSubmit}>
                <Stack
                  wrap
                  tokens={wrapStackTokens}
                  styles={{ root: { padding: "10px" } }}
                >
                  <Stack.Item>
                    <CustomTextField
                      name={"newPassword"}
                      type="password"
                      label={"Update Password"}
                      placeholder="Enter new password"
                    />
                  </Stack.Item>
                  {errors.newPassword &&
                    touched.newPassword &&
                    values.newPassword && (
                      <Stack.Item>
                        <PasswordPolicy password={values.newPassword} />
                      </Stack.Item>
                    )}
                  <Stack.Item align="end">
                    <DefaultButton
                      text="Cancel"
                      onClick={() => {
                        updatePassword(false);
                      }}
                      className="borderless-btn"
                    />
                    &nbsp;&nbsp;
                    <PrimaryButton text="Update" type="submit" />
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Callout>
      )} */}
    </React.Fragment>
  );
};

export default AdminMain;
